import React, { useState } from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

import NewMediaPopup from '@/pages/opinion/pages/feeds/components/NewMediaPopup/index';
import moment from 'moment';
import { transChannel } from '@/pages/opinion/utils';
import TruncateLineCommon from '@/pages/opinion/components/TruncateLineCommon';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import { openWindowUrl } from '@/pages/opinion/utils/url';
import { keywordRenderFunc } from '@/pages/opinion/utils/text';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';

// from pages/opinion/feeds/Feeds/common/NewsList.tsx

export default function NewMediaBox(props: any) {
  const {
    item: { source, release_time, md5_uni, news_url },
    language,
    search,
    deleteItem,
  } = props;
  const [visible, setVisible] = useState(false);
  const { formatMessage } = useIntl();
  // 文字搜索高亮示例，添加text-highlight类
  // <span className="text-highlight">Good</span>

  const keyMap: any = {
    en: {
      titleKey: 'title_en',
      contentKey: 'content_en',
    },
    zh: {
      titleKey: 'title_cn',
      contentKey: 'content_cn',
    },
    origin: {
      titleKey: 'news_title',
      contentKey: 'content',
    },
  };

  const { titleKey, contentKey } = keyMap[language] || keyMap['origin'];

  const textContent =
    search?.trim().length > 0
      ? keywordRenderFunc({
          text: props.item[contentKey],
          keyword: search,
        })
      : props.item[contentKey];
  const textTitle = props.item[titleKey];
  const textChannel = transChannel(source);
  const textTime = moment(release_time).format('YYYY-MM-DD HH:mm');
  const region = props.item.region || 'global';

  return (
    <div
      className="feeds-newmediabox"
      onClick={() => {
        setVisible(true);
      }}
    >
      <div className="feeds-newmediabox-hd">
        <div className="feeds-newmediabox-title">
          <div className="newmediabox-tit">{textTitle}</div>
          {news_url && (
            <Bubble
              dark
              placement="top"
              content={formatMessage({ id: 'Go to original post' })}
            >
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(news_url);
                }}
              >
                <SvgIcon className="newmediabox-icon" type="other-share-icon" />
              </span>
            </Bubble>
          )}
        </div>
      </div>

      <div className="feeds-newmediabox-bd">
        <TruncateLineCommon
          className={'newmediabox-content'}
          content={textContent}
          uid={md5_uni}
        />
      </div>
      <div className="feeds-newmediabox-info">
        <RegionCountryItem
          market={region}
          showText={false}
          className={`newmediabox-region ${region}`}
        ></RegionCountryItem>
        <SvgIcon type="appfamitsu-icon" className="feeds-mediapopup-icon" />
        <div className="newmediabox-infotext">{textChannel}</div>
        <div className="newmediabox-infotext">{textTime}</div>
      </div>
      {/* <div className="right-delete-icon">
        <SvgIcon
          type="clear-icon"
          onClick={(event) => {
            event.stopPropagation();
            deleteItem?.();
          }}
        />
      </div> */}
      <NewMediaPopup
        visible={visible}
        close={() => setVisible(!visible)}
        confirm={() => openWindowUrl(news_url)}
        caption={transChannel(source)}
        title={textTitle}
        content={textContent}
        region={region}
        time={textTime} // 这两个感觉要修改，没有通用性
        channel={textChannel} // 这两个感觉要修改，没有通用性
      />
    </div>
  );
}
